<template>
    <div>
        <div v-if="!hasError" class="s-request-status__results">
            <div v-if="statusResults?.lastUpdatedText" class="s-request-status__results__date">
                {{ statusResults.lastUpdatedText }}
            </div>
            <div class="s-request-status__results__status">{{ statusResults?.statusText }}</div>
        </div>
        <ResponseError v-else :error-messages="errorMessages" />
    </div>
</template>

<script>
import ResponseError from 'Root/vue/components/ResponseError.vue'

export default {
    components: {
        ResponseError,
    },

    props: {
        statusResults: {
            type: Object,
            default: null,
        },
        errorMessages: {
            type: String,
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
